import api from '../../api';
import { Permissao } from '../../model/Usuario/Permissao';

interface ApiError { 
    response?: { 
        data: { message: string; }; 
        status: number; 
    }; 
}

export class PermissaoViewModel {
    static async obterPermissoes(): Promise<Permissao[]> {
        try {
            const response = await api.get('/perfis/permissoes');
            return response.data.map((permissao: any) => this.mapPermissao(permissao));
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                throw new Error(apiError.response?.data.message || 'Erro ao obter permissões');
            }
            throw new Error('Erro desconhecido ao obter permissões');
        }
    }

    private static mapPermissao(permissaoData: any): Permissao {
        return {
            id: permissaoData.id,
            nome: permissaoData.nome,
            descricao: permissaoData.descricao,
            categoria: '' 
        };
    }
}
